module.exports = __webpack_public_path__ + "img/dink-living-3.bc2aa575.jpeg";